import { useQuery } from '@tanstack/react-query';

import { conversationKeys } from './conversationKeys';

import { api } from '@/lib/api';

/**
 * How often the header badge asks again, in milliseconds.
 *
 * Warning: polling, not a socket. `socket.io-client` costs ~15 Ko gzip and the
 * budget has 8 to spare — see docs/features/messaging.md for when that gets
 * revisited.
 */
const POLL_MS = 60_000;

/**
 * The number on the messages icon.
 *
 * Warning: its own module, apart from the screens' hooks. `AppLayout` mounts
 * this on every authenticated screen, so anything sharing a file with it lands
 * in the initial chunk.
 *
 * @returns The React Query result holding the unread count.
 */
export function useMessagesUnread() {
  return useQuery({
    queryKey: conversationKeys.unread(),
    queryFn: () => api.conversations.unreadCount(),
    refetchInterval: POLL_MS,
    refetchOnWindowFocus: true,
  });
}
